// extracted by mini-css-extract-plugin
export default {"cls1":"LoswpBulkDownloadButton-cls1_CpU","cls2":"LoswpBulkDownloadButton-cls2_iRP LoswpBulkDownloadButton-cls1_CpU"};